import React from "react";
import { connect } from "react-redux";
import { Button,  Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import InputMask from 'react-input-mask'
import { Field, reduxForm, formValueSelector } from "redux-form";
import IntlMessages from "util/IntlMessages";
import DayPickerInput from "react-day-picker/DayPickerInput";
import moment from "moment";
import DragAndDown from "../DragAndDropImage";
import { customerOnShowLoader, setCustomerImageFile,deleteGalleryImage } from "../../actions";
import ReactDOM from 'react-dom';
import CircularProgress from "../CircularProgress";
import { YearMonthForm, fromMonth, toMonth } from "./YearMonthForm";
// import NumberFormat from 'react-number-format';
import normalizePhone from '../../util/normalizePhone'
import { phoneMask } from '../../util/consts';

class CustomerForm extends React.Component {
  constructor() {
    super();
    this.state = {
      accepted: [],
      rejected: [],
      month: fromMonth,
      gallerymodal:false,
      itemToDelete:[]
    };
  }
  componentDidMount() {
    ReactDOM.findDOMNode(this).scrollIntoView();
  }
  onDrop = (accepted, rejected) => {
    this.props.setCustomerImageFile(accepted[0]);
    this.setState({ accepted, rejected });
  };

  handleYearMonthChange = month => {
    this.setState({ month });
  };

  renderPhoneInput = ({
    input,
    placeholder,
    name,
    className,
    type,
    classType,
    height,
    labelName,
    colName,
    required,
    meta: { touched, error },
  }) => (
      <div className={`${colName} col-12`}>
        <div className={`form-group ${classType}`}>
          <label htmlFor={name}>
            <IntlMessages id={labelName} />
            {required ? <span className="text-danger">*</span> : null}
          </label>
          <InputMask
            {...input}
            alwaysShowMask={false}
            mask={phoneMask}
            style={{ height }}
            className={className}
            id={name}
            name={name}
            placeholder={placeholder}
            type={type}
          />
          {touched &&
            (error && (
              <span className="error-message">
                <IntlMessages id={error} />
              </span>
            ))}
        </div>
      </div>
    )

  renderInput = ({
    input,
    placeholder,
    name,
    className,
    type,
    classType,
    height,
    colName,
    labelName,
    required,
    disabled,
    meta: { touched, error, warning },
  }) => (
      <div className={`${colName} col-12`}>
        <div className={`form-group ${classType}`}>
          <label htmlFor={name}>
            <IntlMessages id={labelName} />
            {required ? <span className="text-danger">*</span> : null}
          </label>
          <input
            {...input}
            disabled={disabled}
            style={{ height }}
            className={className}
            id={name}
            name={name}
            {...input}
            placeholder={placeholder}
            type={type}
          />
          {touched &&
            (error && (
              <span className="error-message">
                <IntlMessages id={error} />
              </span>
            ))}
        </div>
      </div>
    );

  renderSelectCustomer = ({
    input,
    name,
    className,
    meta: { touched, error, warning },
    arrayName,
    labelName,
    disabled,
    required,
  }) => (
      <div className="col-md-6 col-12">
        <div className="form-group">
          <label htmlFor={name}>
            <IntlMessages id={labelName} />
            {required ? <span className="text-danger">*</span> : null}
          </label>
          <select {...input} className={className} name={name} disabled={disabled}>
            <option value="male">
              Male
            {/* <IntlMessages id="customer.form.male" /> */}
            </option>
            <option value="female">
              Female
            {/* <IntlMessages id="customer.form.female" /> */}
            </option>
          </select>
          {touched &&
            (error && (
              <span className="error-message">
                <IntlMessages id={error} />
              </span>
            ))}
        </div>
      </div>
    );

  renderDragAndDrop = ({
    input,
    className,
    name,
    classType,
    labelName,
    colName,
    onDrop,
    imageName,
    handleRemove,
    imageid,
    meta: { touched, error, warning },
  }) => (
      <div className={`${colName} col-12`}>
        <div className={`form-group ${classType}`}>
          <label htmlFor={name}>
            <IntlMessages id={labelName} />
          </label>
          <DragAndDown onDrop={onDrop} name={name} id={name} {...input} imageName={imageName}  handleRemove={handleRemove} imageid={imageid}/>
          {imageName ? imageName.name : null}
          {/* {touched && (error && <span className="error-message">{error}</span>)} */}
        </div>
      </div>
    );

  // renderSelect = ({ input, name, className, type, classType, checked, colName }) => (
  //   <div className={`${colName} col-12`}>
  //     <div className={`form-group ${classType}`}>
  //       <label className={className}>
  //         <select {...input} type={type} id={name} name={name} />
  //         <option value="male" />
  //         <option value="female" />
  //       </label>
  //     </div>
  //   </div>
  // );

  // onSubmit = formValues => {
  //
  // };

  // phoneFormatter = (number) => {
  //   // if (!number) return '';
  //   // // NNN-NNN-NNNN
  //   // const spliter1=/.{1,3}/g;
  //   // const splitter = /.{1,3}/g;
  //   // number = number.substring(0, 10);
  //   // return number.substring(0, 7).match(splitter).join('-') + number.substring(7);

  // return number.replace(/\s+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  // };

  // phoneParser = (number) => number ? number.replace(/-/g, '') : '';

  // changetest = value => {
  // value.currentTarget.defaultValue = value.currentTarget.defaultValue + " okay";
  // this.phoneRef.current.value = value + '+';
  // console.log("TCL: CustomerForm -> this.phoneRef.current", this.phoneRef.current)
  // }
  modalToggle = () => {
    this.setState({ gallerymodal:false });
  };
  showDeleteConfirmationModalGallery = item => {
    this.setState({ gallerymodal: true,itemToDelete:item });
  }
  handleImageRemove = currentImg => {
    console.log("DELETE IMAGE", currentImg);
    const id=currentImg._id;
    let delteData={
      from:"customer",
      id:id
    }
    this.props.deleteGalleryImage(delteData);
    this.modalToggle();
  };
  render() {
    const {
      viewCustomer,
      loader,
      customCancelAndSubmitButtons,
      customerClearFormData,
      changeCustomerAdminDisplay,
    } = this.props;

    const submitButton = loader ? (
      <CircularProgress />
    ) : (
        <Button className="btn btn-vibo2" size="md" type="submit">
          <IntlMessages id="vibo.customer.form.submit" />
        </Button>
      );
    const closeBtn = (
      <button className="close" onClick={this.modalToggle}>
        &times;
      </button>);
    const bottom = customCancelAndSubmitButtons ? (
      <div className="text-right w-100">
        <Button
          className="btn btn-light"
          size="md"
          onClick={() => {
            customerClearFormData();
            changeCustomerAdminDisplay(1);
          }}
        >
          <IntlMessages id="vibo.customer.form.cancel" />
        </Button>
        {submitButton}
      </div>
    ) : null;

    return (
      
      <div className="row employee-form" style={{ paddingBottom: '35px' }}>
        <div>
        <Modal isOpen={this.state.gallerymodal} >
          <ModalHeader toggle={this.modalToggle} close={closeBtn}>
            <IntlMessages id="vibo.deleteConfirmation.gallery.modal.header" />
          </ModalHeader>
          <ModalBody className="">
            <IntlMessages id="vibo.deleteConfirmation.gallery.modal.body" />
          </ModalBody>
          <ModalFooter>
            <React.Fragment>
              <Button
                size="md"
                className="btn btn-light"
                onClick={() => {
                  this.modalToggle();
                }}
              >
                <IntlMessages id="vibo.deleteConfirmation.gallery.modal.no" />
              </Button>
              <Button
                className="btn btn-vibo2"
                size="md"
                onClick={() => {
                  this.handleImageRemove(this.state.itemToDelete);
                }}
              >
                <IntlMessages id="vibo.deleteConfirmation.gallery.modal.yes" />
              </Button>
            </React.Fragment>
          </ModalFooter>
        </Modal>
      </div>
        <div className="col-12">
          <form onSubmit={this.props.handleSubmit(this.props.onSubmit)} className="pad-30">
            <div className="row">
              <Field
                name="firstname"
                component={this.renderInput}
                placeholder="John"
                type="text"
                className="form-control form-control-md"
                height="35px"
                classType=""
                colName="col-md-6"
                labelName="vibo.customer.form.firstname"
                required
              />
              <Field
                name="lastname"
                component={this.renderInput}
                placeholder="Doe"
                type="text"
                className="form-control form-control-md"
                height="35px"
                classType=""
                colName="col-md-6"
                labelName="vibo.customer.form.lastname"
                required
              />
            </div>
            <div className="row">
              <Field
                name="email"
                component={this.renderInput}
                placeholder="johndoe@gmail.com"
                type="email"
                className="form-control form-control-md"
                height="35px"
                classType=""
                colName="col-md-6"
                labelName="vibo.customer.form.email"
                required
              />
              {/* <Field
                name="phonenumber"
                component={this.renderInput}
                placeholder="+1 (111) 222-4444"
                type="tel"
                normalize={normalizePhone}
                className="form-control form-control-md"
                classType=""
                height="35px"
                colName="col-md-6"
                labelName="vibo.customer.form.phoneNumber"
              /> */}
              <Field
                name='phonenumber'
                component={this.renderPhoneInput}
                placeholder="+1 (000) 000-0000"
                type="text"
                className="form-control form-control-md"
                height="35px"
                colName="col-md-6"
                classType=""
                labelName="vibo.employees.form.phoneNumber"
                required
              />
              {/* <div class="col-md-6 col-12">
                <div class="form-group ">
                  <label><span><IntlMessages id="vibo.customer.form.phoneNumber" /></span><span class="text-danger">*</span></label>
                  <NumberFormat placeholder="+1 (111) 222-4444" className="form-control form-control-md" style={{height:"35px"}} name="phonenumber" format="+1 (###) ### ####" mask="_" />
                </div>
              </div>               */}
            </div>

            <div className="row ">
              <Field
                name="address1"
                component={this.renderInput}
                placeholder="Address line 1"
                type="text"
                className="form-control form-control-md"
                height="35px"
                classType=""
                colName="col-md-6"
                labelName="vibo.customer.form.address1"
              />
              <Field
                name="address2"
                component={this.renderInput}
                placeholder="Address line 2"
                type="text"
                className="form-control form-control-md"
                height="35px"
                classType=""
                colName="col-md-6"
                labelName="vibo.customer.form.address2"
              />
            </div>
            <div className="row ">
              <Field
                name="city"
                component={this.renderInput}
                placeholder="City"
                type="text"
                className="form-control form-control-md"
                height="35px"
                classType=""
                colName="col-md-6"
                labelName="vibo.customer.form.city"
              />
              <Field
                name="stateId"
                component={this.renderInput}
                placeholder="State"
                type="text"
                className="form-control form-control-md"
                height="35px"
                classType=""
                colName="col-md-6"
                labelName="vibo.customer.form.state"
              />
            </div>
            <div className="row">
              <Field
                name="country"
                component={this.renderInput}
                placeholder="Country"
                type="text"
                className="form-control form-control-md"
                height="35px"
                classType=""
                colName="col-md-6"
                labelName="vibo.customer.form.country"
              />
              <Field
                name="zipcode"
                component={this.renderInput}
                placeholder="Zipcode"
                type="number"
                className="form-control form-control-md"
                height="35px"
                classType=""
                colName="col-md-6"
                labelName="vibo.customer.form.zipcode"
              />
            </div>
            <div className="row ">
              <Field
                name="gender"
                component={this.renderSelectCustomer}
                className="form-control form-control-md"
                height="35px"
                classType=""
                colName="col-md-6"
                labelName="vibo.customer.form.gender"
              />
              <div className="col-md-6 col-12">
                <div className="form-group">
                  <label>
                    <IntlMessages id="vibo.customer.form.dateOfBirth" />
                  </label>
                  <DayPickerInput
                    value={moment(this.props.dateOfBirth).format("YYYY-MM-DD")}
                    onDayChange={this.props.handleDateOfBirth}
                    dayPickerProps={{
                      selectedDays: [this.props.dateOfBirth],
                      month: this.state.month,
                      fromMonth,
                      toMonth,
                      captionElement: ({ date, localeUtils }) => (
                        <YearMonthForm
                          date={date}
                          localeUtils={localeUtils}
                          onChange={this.handleYearMonthChange}
                        />
                      ),
                      // modifiers: {
                      //   disabled: [{ after: new Date(1950, 1, 1) }],
                      // },
                    }}
                    placeholder="Select Date Of Birth"
                    name="customerDateOfBirth"
                    colName="col-md-6"
                    keepFocus={false}
                    inputProps={{ readOnly: true }}
                  />
                </div>
              </div>
            </div>
            <div className="row" />
            {this.props.dragAndDrop ? (
              <div className="row">
                <Field
                  name="filedrop"
                  component={this.renderDragAndDrop}
                  className="form-control form-control-md"
                  height="35px"
                  classType=""
                  colName="col-md-6"
                  labelName="vibo.customer.form.photo"
                  onDrop={this.onDrop}
                  imageName={this.props.imageFile}
                  imageid={this.props.imageid}
                  handleRemove={()=>this.showDeleteConfirmationModalGallery(this.props.imageFile)}
                />
              </div>
            ) : null}
            {bottom}
          </form>
        </div>
      </div>
    );
  }
}

const validate = formValues => {
  const errors = {};
  if (!formValues.firstname) {
    errors.firstname = "vibo.error.form.firstname";
  }
  // if (!formValues.address1) {
  //   errors.address1 = "You must enter Address 1";
  // }
  // if (!formValues.city) {
  //   errors.city = "You must enter City";
  // }
  // if (!formValues.stateId) {
  //   errors.stateId = "You must enter State";
  // }
  // if (!formValues.zipcode) {
  //   errors.zipcode = "You must enter Zipcode";
  // } else if (formValues.zipcode.length !== 5) {
  //   errors.zipcode = "You must enter valid zipcode ";
  // }
  // if (!formValues.gender) {
  //   errors.gender = "vibo.error.form.gender";
  // }
  // if (!formValues.country) {
  //   errors.country = "You must Enter Country";
  // }
  if (!formValues.lastname) {
    errors.lastname = "vibo.error.form.lastname";
  }
  if (formValues.zipcode && !/^[0-9]+/g.test(formValues.zipcode)) {
    errors.zipcode = "vibo.error.form.zipcode";
  } else if (formValues.zipcode && formValues.zipcode.length !== 5) {
    errors.zipcode = "vibo.error.form.validZipcode";
  }

  if (!formValues.email) {
    errors.email = "vibo.error.form.email";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formValues.email)) {
    errors.email = "vibo.error.form.validEmail";
  }
  if (
    formValues.phonenumber &&
    !/^([+]{1})([1]{1})([0-9]{3})([0-9]{3})([0-9]{4})$/g.test('+' + formValues.phonenumber.replace(/[^\d]/g, ''))
  ) {
    errors.phonenumber = "vibo.error.form.validPhoneNumber";
  }

  return errors;
};

const selector = formValueSelector("CustomerForm");

// const mapDispatchToProps = dispatch => ({
//   setImageFile: payload => dispatch(actions.setCustomerImageFile(payload)),
// });

CustomerForm = reduxForm({
  form: "CustomerForm",
  validate,
  touchOnChange: true,
  enableReinitialize: true,
  // config: true
})(CustomerForm);

CustomerForm = connect(
  state => ({
    // dataOfForm: selector(state, "firstName", "lastName", "email", "phoneNumber", "title"),
    initialValues: state.customerAdmin.customerDetails,
    imageFile: state.customerAdmin.imageFile,
    loader: state.customerAdmin.customerLoader,
    imageid:state.customerAdmin.imageid
  }),
  { customerOnShowLoader, setCustomerImageFile, deleteGalleryImage },
  null,
  { withRef: true }
)(CustomerForm);

export default CustomerForm;



// WEBPACK FOOTER //
// ./components/adminForms/CustomerForm.js